<template>
    <div id="app">
        <div class="app-inner">
            <div class="wrapper wrapper-inset">
                <Navigation />
            </div>
            <transition
                name="fade"
                mode="out-in">
                <router-view/>
            </transition>
        </div>
        <footer class="site-footer">
            <div class="wrapper wrapper-inset">
                <div class="site-footer-content">
                    <p class="links">
                        <router-link to="/opensourcejob">What is an Open Source Job?</router-link>
                        <router-link to="/termsofservice">Terms of Service</router-link>
                        <router-link to="/about">About Open Source Jobs</router-link>
                        <router-link to="/opensourcescore">Open Source Score</router-link>
                        <router-link to="/faq">FAQ</router-link>
                    </p>
                    <p class="links">Copyright 2022</p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Navigation from '@/components/Navigation.vue'

export default {
    name: 'home',
    components: {
        Navigation
    },
    methods : {
        ...mapActions([
            'toggleNav'
        ]),
        isMobile(){
            this.$store.commit( 'setIsMobile', window.innerWidth < 800 )
        },
        afterLeave () {
          this.$root.$emit('triggerScroll')
        }
    },
    beforeMount(){
        this.isMobile()
        window.addEventListener( "resize", this.isMobile )
    },
    computed : {
        open(){
            return this.$store.state.navopen
        }
    }
}
</script>

<style lang="scss">
    @import "scss/reset";
    @import "scss/vars";
    @import "scss/base";
    @import "scss/wrapper";

    body{
        background-color: $black;
    }

    #app{
        > .wrapper{
            overflow: hidden;
            border-radius: $radius;
        }
    }

    .app-inner{
        background-color: white;
    }

    .site-footer{
        a{
            color: white;
            text-decoration: none;
            font-weight: 700;
            &:hover {
                text-decoration: underline;
            }
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
    
    .site-footer{

        &-content{
            padding: 2rem 0;
            color: white;
            .links{
                text-align: center;
                a{
                    display: inline-block;
                    padding: 0.5rem 1rem;
                }
            }
        }
    }
</style>
